import React from "react";

function AppCardBody({ inset = "default", className = "", children, ...rest }) {
  const classes = [
    "ds-card__body",
    inset === "none" ? "ds-card__body--inset-none" : "ds-card__body--inset-default",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

AppCardBody.appCardZone = "body";

export default AppCardBody;
